import { Component, Inject } from '@angular/core';
import { MAT_SNACK_BAR_DATA, MatSnackBarRef } from '@angular/material/snack-bar';
import { Router } from '@angular/router';

@Component({
    selector: 'app-snackbar',
    templateUrl: './snackbar.component.html',
    standalone: false
})
export class SnackbarComponent {
  constructor(
    public snackbarRef: MatSnackBarRef<SnackbarComponent>,
    private router: Router,
    @Inject(MAT_SNACK_BAR_DATA) public data: any
  ) {
    this.data = data;
  }

  /** Performs the action on the snack bar. */
  action(): void {
    this.snackbarRef.dismissWithAction();
  }
  /*
  routeToMyErrors(): void {
    this.router.navigate(['/secure/user/errors']);
    this.snackbarRef.dismissWithAction();
  }
  */

  /** If the action button should be shown. */
  get hasAction(): boolean {
    return !!this.data.action;
  }
}
